<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QjR7db/tc-custom/9781460317570.jpg?1705766051071" alt="This image is the cover for the book Dance with the Rancher, Undone!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dance with the Rancher, Undone!
      </h1>
      <p class="bookDescription body article font2">
        <i>Colorado, 1879<i><br/><br/>Jilted once, Garret McCoy has sworn never to fall in love again. But that doesn’t stop him from wanting to have a little fun, and he bets he can be the man to get the preacher’s shy daughter out on the dance floor. He never gambled on her stealing his heart, though!<br/><br/>Rory Boyle has kept to herself, fearful if the townsfolk learn her secret, she’ll be an outcast. But she can’t resist taking a turn with the handsome but ornery Garret. Or giving in to his kisses</i></i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lauri Robinson
      </h2>
      
      <p class="authorDescription body article">Lauri Robinson lives in Minnesota where she and her husband spend every spare moment with their three grown sons and their families&mdash;spoiling the grandchildren. She&rsquo;s a member of Romance Writers of America and Northern Lights Writers. Along with volunteering for several organizations, she is a diehard Elvis and NASCAR fan. Her favorite getaway location is along the Canadian Border of Northern Minnesota on the land homesteaded by her great-grandfather.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c0f7ce96